<template>
  <div :class="`col-md-${width} form-group`">
    <label v-if="label" class="control-label">
      {{ `${label} ${required ? '*' : ''}` }}
    </label>
    <p v-if="help" class="help-block">{{ help }}</p>
    <input
      type="number"
      class="form-control"
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :readonly="readonly"
      :value="value"
      @input="$emit('input', $event.target.valueAsNumber)"
    />
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '12' },
    placeholder: { type: String, default: '' },
    value: { type: [Number, String], default: '' },
    name: { type: String, required: true },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    label: String,
    help: String,
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/inputs/number.vue